import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconPlayDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="M7.791 2.695a1.25 1.25 0 0 0-1.92 1.055v17.5a1.25 1.25 0 0 0 1.92 1.055l13.75-8.75a1.25 1.25 0 0 0 0-2.11z" /></svg></>;
}
export default IconPlayDefault;